import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import * as net from 'util/Net';

import {RequestTemplateGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTemplateGraphQL';
import {RequestTemplate, RequestTemplateSpec} from './RequestTemplateConstants';

interface FetchAllRequestTemplatesResponse {
  templates: Array<RequestTemplate>;
}

export function fetchAllRequestTemplates(): Promise<FetchAllRequestTemplatesResponse> {
  return Promise.resolve(net.getJSON('/1/api/request-templates'));
}

export interface BulkRequestTemplateResponse {
  templates: Array<RequestTemplate>;
  schemaSpecs: Array<RequestTemplateSpec>;
}

export function bulkFetchRequestTemplates(
  requestTemplateIds: Array<string>
): Promise<BulkRequestTemplateResponse> {
  return net.postJSONPromise({
    url: '/1/api/request-templates:bulk-get',
    data: {requestTemplateIds},
  });
}

export interface CreateRequestTemplateResponse {
  requestSchema: AssaySchema;
  template: RequestTemplate;
  templateGraphQL: RequestTemplateGraphQL;
}

export function createRequestTemplate(requestSchemaId: string): Promise<CreateRequestTemplateResponse> {
  return net.postJSONPromise({
    url: '/1/api/request-templates',
    data: {requestSchemaId},
  });
}

export interface RequestTemplateResponse {
  template: RequestTemplate;
  schemaSpec: RequestTemplateSpec;
  templateGraphQL: RequestTemplateGraphQL;
}

export function updateRequestTemplate(
  requestTemplateId: string,
  spec: RequestTemplateSpec
): Promise<RequestTemplateResponse> {
  return net.patchJSONPromise({
    url: `/1/api/request-templates/${requestTemplateId}`,
    data: {spec},
  });
}
